import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import {MessagesService} from '../services/messages.service';
import {UIMessage} from './ui-message.model';
import {MatIconModule} from '@angular/material/icon';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
    selector: "messages",
    templateUrl: "./messages.component.html",
    styleUrls: ["./messages.component.scss"],
    imports: [
    NgClass,
    MatIconModule,
    AsyncPipe
],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessagesComponent {
  messages = inject(MessagesService);

  readonly style = input<"normal" | "dialog">("normal");

  messageType(message: UIMessage) {
    return ["messages-" + message.type, this.style() + "-messages"];
  }

  clearError() {
    this.messages.clear();
  }
  getMessageIcon(messageType: string) {
    switch (messageType) {
      case "error":
        return "cancel";
      case "warn":
        return "error";
      case "success":
        return "check_circle";
      case "info":
        return "info";
      default:
    }
  }
}
